import { toast } from 'react-toastify';
import { globalErrorHandler } from "../../utils/ErrorHandler";

/**
 * Show error toast with safe, generic message
 * Prevents exposure of sensitive backend information
 */
export const showError = (error, context = 'Error') => {
  try {
    // Get safe message from global handler
    const userMessage = globalErrorHandler.getUserMessage(error);
    
    // Show toast notification
    toast.error(userMessage, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  } catch (err) {
    // Fallback if something goes wrong
    console.error("Error in showError:", err);
    toast.error("Something went wrong. Please try again.", {
      position: "top-right",
      autoClose: 5000,
    });
  }
};

/**
 * Show generic toast notification
 */
export const showToast = (title, message, type = "info", duration = 5000) => {
  try {
    const toastConfig = {
      position: "top-right",
      autoClose: duration,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    };

    const displayMessage = title ? `${title}: ${message}` : message;

    switch(type) {
      case "error":
        toast.error(displayMessage, toastConfig);
        break;
      case "success":
        toast.success(displayMessage, toastConfig);
        break;
      case "warning":
        toast.warning(displayMessage, toastConfig);
        break;
      default:
        toast.info(displayMessage, toastConfig);
    }
  } catch (err) {
    console.error("Error in showToast:", err);
  }
};

/**
 * Success notification helper
 */
export const showSuccess = (message, duration = 3000) => {
  toast.success(message, {
    position: "top-right",
    autoClose: duration,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

/**
 * Warning notification helper
 */
export const showWarning = (message, duration = 4000) => {
  toast.warning(message, {
    position: "top-right",
    autoClose: duration,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};